import Loader from "react-loader-spinner";
import momentJalaali from "moment-jalali";
import { faHistory, faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Card, Col, Row } from "react-bootstrap"
import DatePicker from "react-datepicker2"
import { exportToExcel, isWebApp } from "../../store/api/CommonFunctions";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { serviceTurnaroundTime } from "../store/api/Services";
import { FileEarmarkExcelFill, Printer, Search, Table } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import BihamtaTable from "../../Components/BihamtaTable";

export default function ServiceTurnaroundTimeReport() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const [dateFilters, setDateFilters] = useState({
        ContactDateFrom: momentJalaali(new Date()).format("YYYY-MM-DD"),
        PContactDateFrom: momentJalaali(new Date()).format("jYYYY/jMM/jDD"),
        ContactDateTo: momentJalaali(new Date()).format("YYYY-MM-DD"),
        PContactDateTo: momentJalaali(new Date()).format("jYYYY/jMM/jDD")
    });
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "PFirstContactDate", colTitle: "تاریخ پذیرش", showInMobile: true },
        { colName: "InvoiceNumber", colTitle: "شماره پذیرش", showInMobile: true },
        { colName: "PServiceType", colTitle: "نوع سرویس" },
        {colName:"TotalTime", colTitle:"مدت زمان اسمی گردش کار(دقیقه)"},
        {colName:"StoppedTime", colTitle:"مدت زمان توقف کار(دقیقه)"},
        {colName:"TurnaroundTime", colTitle:"مدت زمان واقعی گردش کار(دقیقه)"},
        { colTitle: "", colName: "ServiceID", style: { display: "none" }, headerStyle: { display: "none" } },
        { colTitle: "", colName: "ServiceType", style: { display: "none" }, headerStyle: { display: "none" } }

    ]
    function search() {
        dateFilters.PDateFrom = document.getElementsByName("dateFrom")[0].value;
        if (dateFilters.PDateFrom === "") {
            dateFilters.ContactDateFrom = null;
        }
        dateFilters.PDateTo = document.getElementsByName("dateTo")[0].value;

        if (dateFilters.PDateTo === "") {
            dateFilters.ContactDateTo = null;
        }
        dispatch(serviceTurnaroundTime(dateFilters.ContactDateFrom, dateFilters.ContactDateTo));
    }
    function showService(row) {
        history.push(`/Services/Service/${row.ServiceID}/${row.ServiceType}`, null);
    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/ServiceTurnaroundTime`;
        setPending(true);
        const searchArgs = { dateFrom: dateFilters.ContactDateFrom, dateTo: dateFilters.ContactDateTo };
        exportToExcel("ServiceTurnaroundTimeReport", searchArgs, url, "get", tableCols, () => setPending(false));
    }
    function printReport(e) {
        //const searchArgs = { dateFrom: dateFilters.ContactDateFrom, dateTo: dateFilters.ContactDateTo };
        history.push({
            pathname: `/PrintViewer/ServiceTurnaroundTimeReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/ServiceTurnaroundTime?dateFrom=${dateFilters.ContactDateFrom}&dateTo=${dateFilters.ContactDateTo}`,
                method: "get",
                fetchBody: JSON.stringify(dateFilters)
            }
        });
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    }, [])
    return (
        <div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faHistory} size='lg' />&nbsp;
                    مدت زمان گردش کار در پذیرش</Card.Header>
                <Card.Body className="bodyStyle" style={{textAlign:"right"}}>
                    <Row className="rowBorder">
                        <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "2px" : "0.75rem" }}>
                        <label>تاریخ پذیرش از: </label>
                            <DatePicker  isGregorian={false} timePicker={false} className="search-input" name="dateFrom"
                                onChange={value => setDateFilters({ ...dateFilters, ContactDateFrom: value.local("en").format("YYYY-MM-DD") })}
                                value={dateFilters?.ContactDateFrom ? momentJalaali(dateFilters.ContactDateFrom) : null} />
                        </Col>
                        <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "2px" : "0.75rem" }}>
                        <label>تاریخ پذیرش تا:</label>
                            <DatePicker isGregorian={false} timePicker={false} className="search-input" name="dateTo"
                                onChange={value => setDateFilters({ ...dateFilters, ContactDateTo: value.local("en").format("YYYY-MM-DD") })}
                                value={dateFilters?.ContactDateTo ? momentJalaali(dateFilters.ContactDateTo) : null} />
                        </Col>
                    </Row>
                    <div className="mt-1" style={{textAlign:"right"}}>
                        <Button className="group-Btn-large" onClick={search}><Table size={18} />&nbsp;نمایش نتایج</Button>
                    </div>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <Printer onClick={printReport} size={25} style={{ cursor: "pointer" }} className="hoverIcon" color='blue' />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} reducerName="service" objectName="serviceTurnaroundTimeReport" rowClick={showService} fixedHeight/>
                </Card.Body>
            </Card>
        </div>
    )
}